import { Fragment } from 'react'
import { useTheme } from '@emotion/react'
import { useStaticQuery, graphql } from 'gatsby'
import { SectionTitle } from 'chaoskit/src/components'
import { StylesContainerVariables } from 'chaoskit/src/components/Container'

import GradientList from '../global/GradientList'

import {
  ProductSection,
  ProductGridBlock,
  ProductGridBlockContent,
  ProductExpand,
} from '~partials/product/UI'
import Data from '~components/Data'
import { ReactComponent as ReliabilitySVG } from '~media/product/overview/reliability.svg'
import { ReactComponent as TestSVG } from '~media/product/overview/test.svg'
import { ReactComponent as ResiliencySVG } from '~media/product/overview/resiliency.svg'

const ProductOverview = () => {
  const theme = useTheme()

  const {
    file: {
      childMdx: {
        frontmatter: { overview: pageData },
      },
    },
  } = useStaticQuery(graphql`
    query ProductOverviewPageData {
      file(name: { eq: "product" }, absolutePath: { regex: "/src/data/" }) {
        childMdx {
          frontmatter {
            overview {
              reliability {
                heading
                blurb
              }
              resiliency {
                heading
                items {
                  heading
                  blurb
                }
              }
              test {
                heading
                items {
                  blurb
                }
                cta {
                  label
                  url
                }
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Fragment>
      <ProductSection>
        <SectionTitle
          as="h2"
          title={<Data>{pageData.reliability.heading}</Data>}
          sub={<Data>{pageData.reliability.blurb}</Data>}
        />
        <ProductExpand>
          <ReliabilitySVG
            css={{
              width: StylesContainerVariables.base,
              marginRight: '-19%', // Approximation of grid offset in graphic; taking into account max width provided by container
            }}
          />
        </ProductExpand>
      </ProductSection>
      <ProductSection separator>
        <SectionTitle
          as="h2"
          title={<Data>{pageData.resiliency.heading}</Data>}
        />
        <ProductGridBlock size="large">
          <ResiliencySVG
            css={{
              width: '100%',
              maxWidth: 400,
              margin: '0 auto',

              [theme.mq.medium]: {
                maxWidth: 550,

                gridColumn: '1 / span 6',
                gridRow: 1,
              },
            }}
          />
          <ProductGridBlockContent>
            <GradientList items={pageData.resiliency.items} />
          </ProductGridBlockContent>
        </ProductGridBlock>
      </ProductSection>
      <ProductSection separator>
        <SectionTitle as="h2" title={<Data>{pageData.test.heading}</Data>} />
        <ProductGridBlock size="large">
          <TestSVG
            css={{
              width: '100%',
              maxWidth: 350,
              margin: '0 auto',

              [theme.mq.medium]: {
                gridColumn: '1 / span 6',
                gridRow: 1,
              },
            }}
          />
          <ProductGridBlockContent>
            <GradientList items={pageData.test.items} />
          </ProductGridBlockContent>
        </ProductGridBlock>
      </ProductSection>
    </Fragment>
  )
}

export default ProductOverview
